import { render, staticRenderFns } from "./RednessDetail.vue?vue&type=template&id=143b2d7c"
import script from "./RednessDetail.vue?vue&type=script&lang=js"
export * from "./RednessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports